<!--
 * @Description: 
 * @Author: zhaoshuai
 * @Date: 2024-05-15 16:57:38
 * @LastEditTime: 2026-03-23 16:14:51
 * @LastEditors: zhaoshuai
-->
<template>
  <div class="mat-header" v-if="showOr">
    <h2>特许全球金融科技师(CGFT)考试报名系统</h2>
    <div>
      您好， {{ $store.state.UserInfo.userName || userInfo.userName }}！<span
        @click="logout"
        class="logout"
      >
        退出
      </span>
    </div>
  </div>
</template>
<script>
export default {
  name: 'MatHeader',
  data() {
    return {
      Username: '',
      showOr: true,
      userInfo: JSON.parse(localStorage.getItem('userInfo')) || {}
    }
  },
  props: {
    showStatus: { type: Boolean }
  },
  watch: {
    $route(to, from) {
      if (to.name == 'Login') {
        this.showOr = false
      } else {
        this.showOr = true
      }
    }
  },
  methods: {
    logout() {
      // this.$cookies.delCookie('isLogin')
      localStorage.removeItem('userInfo')
      this.$router.push({
        path: '/'
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.mat-header {
  width: 100%;
  height: 112px;
  background: #d49c42;
  color: #ffffff;
  line-height: 112px;
  font-size: 14px;
  display: flex;
  h2 {
    flex: 1;
    display: inline-block;
    font-size: 32px;
    font-weight: normal;
    text-align: left;
    margin-left: 2rem;
  }
  .logout {
    flex: 1;
    display: inline-block;
    color: #32c5ff;
    text-align: left;
    margin-right: 2rem;
  }
  .logout span {
    cursor: pointer;
    color: #e6c687;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/MatHeader.vue